// Reihenfolge der scrollbaren Zusatzspalten, nach Wichtigkeit beim Ablesen:
// Standort (wo ist der Zähler?) → Kunde/Partner (wem gehört er?) → Auftrag
// (Rahmendaten, Zielablesedatum bewusst weit hinten) → Ablesehistorie.
// 'meterRateTask.tariffName' fehlt hier absichtlich: der Tarif gehört zur
// Zähler-Identität und wird im Schema direkt hinter der OBIS eingefroren
// (siehe ColumnSchemaBuilder).
export const CANONICAL_COLUMN_ORDER: string[] = [
    // Standort / Zähleradresse
    'meter.address.street',
    'meter.address.zip',
    'meter.address.city',
    'meter.address.objectKey',
    'meter.address.locationDescription',
    'meter.address.locationHint',
    // Kundendaten
    'customer.customerNumber',
    'customer.name',
    'customer.company',
    'customer.postalAddress',
    'customer.mailingAddress.street',
    'customer.mailingAddress.zip',
    'customer.mailingAddress.city',
    'customer.mailingAddress.postbox',
    'customer.contact.email',
    'customer.contact.phone',
    'customer.contact.mobile',
    // Partner
    'partner.partnerKey',
    'partner.name',
    'partner.partnerCompany',
    'partner.contractId',
    'partner.mailingAddress.street',
    'partner.mailingAddress.zip',
    'partner.mailingAddress.city',
    'partner.mailingAddress.postbox',
    'partner.contact.email',
    'partner.contact.phone',
    'partner.contact.mobile',
    // Auftrag
    'job.externalIdentifier',
    'meterRateTask.maloId',
    'meterRateTask.meloId',
    'meterRateTask.meterType',
    'meterRateTask.unit',
    'meterRateTask.executionDeadline',
    'meterRateTask.targetReadingDate',
    'meterRateTask.validUntil',
    // Ablesungen (Historie)
    'meterRateTask.lastReadingDate',
    'meterRateTask.lastReadingValue',
    'meterRateTask.lastResultDate',
    'meterRateTask.lastResultValue',
];
